import { gql } from '@apollo/client';

export const GET_CHANGE_PLAN_OFFERS = gql`
  query getPlanOffers {
    getPlanOffers {
      id
      offerId
      description
      price
      savings
      disclosure
      isUnlimited
      isCaf

      priceCurrency
      characteristics {
        attributes
        bannerColor
        benefits
        dataAllowanceText
        dataCap
        dataCapUnits
        downloadRange
        downloadRangeText
        downloadSpeed
        downloadUnits
        fiberSpeedText
        inflectionPointText
        offerName
        positioning
        productFamily
        routerText
        serviceAreaId
        tag
        titleAddOns
        upi
        uploadRangeText
        uploadSpeed
        uploadUnits
        usageMeter
        onCallDirective
        onCallDirectiveClientMessage
      }
    }
  }
`;

export const CONFIGURE_CART = gql`
  mutation configureCart($input: ConfigureCartInput!) {
    configureCart(input: $input) {
      id
      requiresEquipmentChange
      hasEquipmentForSelfInstall
      outdoorUnit {
        currentModel
        newModel
      }
      status
      eicRequired
      droppedAddOns {
        name
        productTypeId
      }
      cartItems {
        plan {
          name
          price
          contractTerms
          leaseFeeShortName
          leaseFeePrice
        }
        bundledAddons {
          name
          price
        }
      }
      prices {
        monthly {
          totalWithPromos
          totalWithoutPromos
          lineItems {
            promo
            lease
          }
        }
        oneTime {
          lease
          totalWithPromos
          totalWithoutPromos
          lineItems {
            promo
          }
          feesAndDiscounts {
            fee
            discount
            total
            kind
            id
            name
          }
        }
      }
    }
  }
`;

export const TRANSITION_PLAN = gql`
  mutation transitionPlan($input: TransitionPlanInput!) {
    transitionPlan(input: $input) {
      message
      orderId
      appointment {
        endTime
        startTime
        workOrderScheduled
      }
    }
  }
`;

export const GET_HAS_PENDING_TRANSITION = gql`
  query getHasPendingTransition($refetchData: Boolean, $productInstanceId: ID) {
    getHasPendingTransition(refetchData: $refetchData, productInstanceId: $productInstanceId) {
      isChangePlanDisabled
      hasActivationError
    }
  }
`;

export const GET_EIC_MESSAGES = gql`
  query getEicMessage($input: EicMessageInput!) {
    getEicMessage(input: $input) {
      productTypeId
      eicMessage
      cpqUserConsent
      cpqConsentDatetime
      cpqConsentReferenceId
    }
  }
`;
